import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { PageClientSideFilters } from "@ryde/layout";

import { StationRouteCrudRoutes } from "./crud";

export const StationRoutesPage: FC = () => {
  return (
    <PageContextWrapper entity="stationRoute">
      <PageClientSideFilters />
      <StationRouteCrudRoutes />
    </PageContextWrapper>
  );
};
